(function (module) {
    'use strict';

    function ViewGroupCtrl(
        $scope,
        $timeout,
        envService,
        App,
        Group,
        Includes,
        $state,
        $stateParams,
        Store,
        $mdDialog,
        Display,
        Playlist,
        AppStylesInPlaylist,
        $q,
        utils,
    ) {
        this.setDefault = () => {
            this.selectedIndex = 0;
            this.apps = [];
            this.featuresFlag = envService.read('features');
            this.mode = 'view';
            this.orientation = 'landscape';
            this.disablePreview = true;
        };

        this.getData = () => {
            // RESOLVE
            return Promise.all([this.getGroup(), this.getApps(), this.getPlaylists()])
                .then(([group]) => {
                    return utils.handlePermissions(group);
                })
                .then(([group, apps, playlists]) => {
                    //GROUP
                    this.group = Store.setSingleModelData('groups', group.id, group);
                    if (group.playlistId && group.playlists && group.playlists.id) {
                        this.selectedIndex = 1;
                    }
                    //APPS
                    this.apps = Store.setMultiModelData('apps', apps);
                    if (this.group.appId) {
                        this.selectedApp();
                    }
                    //PLAYLISTS
                    this.playlists = Store.setMultiModelData('playlists', playlists);
                    if (this.group.playlistId) {
                        this.selectedPlaylist();
                    }

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                });
        };

        this.$onDestroy = () => {};

        this.$onInit = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.revert = () => {
            this.form.$setPristine();
            this.setDefault();
        };

        this.getGroup = () => {
            if ($stateParams.group) {
                const deferred = $q.defer();
                $timeout(() => {
                    return deferred.resolve($stateParams.group);
                });
                return deferred.promise;
            } else {
                return Group.findById({
                    id: $stateParams.id,
                    filter: Includes.groups,
                }).$promise;
            }
        };

        this.getApps = () => {
            return App.find({ filter: Includes.apps }).$promise;
        };

        this.getPlaylists = () => {
            return Playlist.find().$promise;
        };

        this.selectedApp = () => {
            this.group.playlistId = null;
            this.group.apps = _.find(this.apps, { id: Number(this.group.appId) });
            if (this.group.apps) {
                this.selectPreviewApp(this.group.apps, this.group.apps.appTemplate);
            } else {
                this.disablePreview = true;
            }
        };

        this.selectedPlaylist = () => {
            this.group.appId = null;
            this.group.playlists = _.find(this.playlists, { id: Number(this.group.playlistId) });
            if (this.group.playlistId && this.group.playlists && this.group.playlists.apps.length) {
                this.group.playlists.apps = AppStylesInPlaylist.getAppStylesInPlaylist(this.group.playlists.apps, this.apps);
            }
            // set preview app
            const appId = _.get(this, 'group.playlists.apps[0].id');
            if (appId) {
                const app = Store.getSingleModelData('apps', appId);
                this.group.playlists.apps.forEach((selectedApp) => {
                    if (selectedApp.id === appId) {
                        selectedApp.active = true;
                    }
                });
                this.selectPreviewApp(app, app.appTemplate);
            } else {
                this.disablePreview = true;
            }
        };

        this.findDisplaysUsingGroupId = (groupId) => {
            return Display.find({
                filter: {
                    where: { groupId },
                    fields: ['id'],
                },
            }).$promise;
        };

        this.cloneGroup = (data) => {
            return Group.create(data).$promise;
        };

        this.getGroupById = (id) => {
            return Group.findById({ id: id, filter: Includes.groups }).$promise;
        };

        this.clone = (id) => {
            const modalTitle = 'You are just about to clone the existing group';
            const modalConfirmationText =
                'Once cloned you will be taken to the new group view. Make sure you save your changes before cloning.';
            const modalCancelText = 'Cancel';
            const modalConfirmText = 'Clone';
            const modalTypeOverride = 'information';
            const confirmActionFunc = (id) => {
                this.getGroupById(id)
                    .then((groupToClone) => {
                        if (!groupToClone) {
                            return console.error('Error cloning app, cannot find group to clone');
                        }

                        const groupToCreate = _.omit(groupToClone, ['id']);
                        groupToCreate.name = `${groupToCreate.name} - copy`;
                        return this.cloneGroup(groupToCreate);
                    })
                    .then(({ id }) => {
                        return this.getGroupById(id);
                    })
                    .then((group) => {
                        return Store.setSingleModelData('groups', group.id, group);
                    })
                    .then((group) => {
                        $state.go('root.groups.view', { id: group.id, groupId: group.id, group: group });
                    })
                    .catch((error) => {
                        console.error('Error cloning group, error from the API', error);
                    });
            };

            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    modalTypeOverride: modalTypeOverride,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(id);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.delete = () => {
            this.findDisplaysUsingGroupId(this.group.id).then((response) => {
                const displaysUsingGroupCount = response && response.length;
                let modalTitle;
                let modalConfirmationText;
                let modalCancelText;
                let modalConfirmText;
                let confirmActionFunc;
                let itemCount1;
                if (displaysUsingGroupCount > 0) {
                    modalTitle = "You can't delete this group as it's being used by :";

                    itemCount1 = displaysUsingGroupCount > 0 ? `${displaysUsingGroupCount + ' of your displays'}` : null;

                    modalConfirmationText = 'Please make sure the group is not being used before deleting.';
                    modalCancelText = 'Ok, I understand';
                } else {
                    modalTitle = 'Are you sure you want to permanently remove this group?';
                    modalConfirmText = 'Yes, remove';
                    modalCancelText = 'Cancel';
                    confirmActionFunc = () => {
                        this.deleteById();
                    };
                }
                $mdDialog.show({
                    locals: {
                        title: modalTitle,
                        confirmationText: modalConfirmationText,
                        cancelText: modalCancelText,
                        confirmText: modalConfirmText,
                        itemCount1: itemCount1,
                    },
                    controller: ($scope, $mdDialog) => {
                        $scope.cancel = () => {
                            $mdDialog.hide();
                        };
                        $scope.confirm = () => {
                            $scope.cancel();

                            confirmActionFunc();
                        };
                    },
                    controllerAs: '$ctrl',
                    bindToController: true,
                    templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                });
            });
        };

        this.deleteById = () => {
            return Group.removeById({ id: this.group.id })
                .$promise.then(() => {
                    return Store.removeSingleModelData('groups', this.group.id);
                })
                .then(() => {
                    $state.go('root.groups');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.reset = () => {
            this.group.name = '';
            this.group.appId = null;
            this.group.playlistId = null;
        };

        this.saveGroup = () => {
            this.saveChanges = () => {
                Group.prototype$patchAttributes(
                    { id: this.group.id },
                    {
                        name: this.group.name,
                        appId: this.group.appId,
                        playlistId: this.group.playlistId,
                    },
                )
                    .$promise.then((res) => {
                        return Group.findById({
                            id: this.group.id,
                            filter: Includes.groups,
                        }).$promise;
                    })
                    .then((group) => {
                        return Store.setSingleModelData('groups', this.group.id, group);
                    })
                    .then(() => {
                        this.form.$setPristine();
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });
            };

            this.findDisplaysUsingGroupId(this.group.id).then((response) => {
                const displaysUsingGroupCount = response && response.length;
                let modalTitle;
                let modalConfirmationText;
                let modalCancelText;
                let modalConfirmText;
                let confirmActionFunc;
                let itemCount1;
                if (displaysUsingGroupCount > 0) {
                    modalTitle = 'Any changes made now to this group wil be also applied to:';

                    itemCount1 = displaysUsingGroupCount > 0 ? `${displaysUsingGroupCount + ' of your displays'}` : null;

                    modalConfirmationText = 'as the group is being used by the above.';
                    modalConfirmText = 'Apply changes';
                    modalCancelText = 'Cancel';
                    const modalTypeOverride = 'information';

                    confirmActionFunc = () => {
                        this.saveChanges();
                    };
                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                            itemCount1: itemCount1,
                            modalTypeOverride: modalTypeOverride,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();

                                confirmActionFunc();
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                } else {
                    this.saveChanges();
                }
            });
        };

        this.goToItemTemplateModal = (event, itemId, type) => {
            event.preventDefault();
            if (this.form.$dirty) {
                this.saveChangesModal(itemId, type);
            } else {
                if (type === 'playlist') {
                    $state.go('root.playlists.edit', { id: itemId });
                }
                if (type === 'app') {
                    $state.go('root.my-apps.edit-app', { appId: itemId });
                }
            }
        };

        this.saveChangesModal = (itemId, type) => {
            $mdDialog.show({
                locals: {
                    title: 'Your changes have not been saved.',
                    confirmationText: 'Are you sure you want to leave this page?',
                    confirmText: 'Yes, I am sure',
                    cancelText: 'Cancel',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $mdDialog.hide();
                        if (type === 'playlist') {
                            $state.go('root.playlists.edit', { id: itemId });
                        }
                        if (type === 'app') {
                            $state.go('root.my-apps.edit-app', { appId: itemId });
                        }
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.onPlaylistAppClicked = (appId) => {
            this.disablePreview = false;
            const app = Store.getSingleModelData('apps', appId);
            this.group.playlists.apps.forEach((selectedApp) => {
                if (selectedApp.id === appId) {
                    selectedApp.active = true;
                } else {
                    selectedApp.active = false;
                }
            });
            this.selectPreviewApp(app, app.appTemplate);
        };

        this.selectPreviewApp = (app, appTemplate) => {
            this.disablePreview = false;
            this.app = app;
            this.appTemplate = appTemplate;

            if (!$scope.$$phase) {
                $timeout(() => {
                    $scope.$apply();
                });
            }
        };
    }

    module
        .config(($stateProvider) => {
            $stateProvider.state('root.groups.view', {
                url: '/:id',
                data: {
                    pageTitle: 'GROUPS_VIEW.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        template: '<group-view-component />',
                    },
                },
                params: {
                    groupId: { value: null },
                    group: { value: null },
                },
            });
        })
        .component('groupViewComponent', {
            controller: ViewGroupCtrl,
            templateUrl: '/js/groups/view-group/view-group.html',
        });
})(angular.module('rocket.components'));
